// extracted by mini-css-extract-plugin
export default {"mainDiv":"navbar_mainDiv__jkcJL"};